import { Button, Menu, MenuItem } from "@mui/material";
import React, { Fragment, memo, useEffect, useState } from "react";
import { MdNotifications } from "react-icons/md";
import { getTokenData } from "../../services/Auth__Service";
import {
  NOTIFICATION_TYPE_DOCUMENT,
  NOTIFICATION_TYPE_FILE,
  NOTIFICATION_TYPE_MEETING,
  NOTIFICATION_TYPE_SHARE_DETAILS,
} from "../../services/Constante";
import {
  findAllByReceiverLogin,
  setRead,
} from "../../services/Notification__Service";
import Modal from "../Modal/Modal";
import ModalDocument from "../Modal/ModalDocument";
import ModalFile from "../Modal/ModalFile";
import ModalMeeting from "../Modal/ModalMeeting";
import ModalShareDetails from "../Modal/ModalShareDetails";

const Notifications = () => {
  // Start
  const fetchAllByReceiver = async (receiver_login) => {
    findAllByReceiverLogin(receiver_login)
      .then((response) => {
        setNotifications(response.data);
      })
      .finally(() => {
        setReload(false);
      });
  };

  const [notifications, setNotifications] = useState([]);
  const [anchorEl, setAnchorEl] = React.useState(null);

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleNotificationClick = (elt) => {
    const id = parseInt(elt.target_link);
    switch (parseInt(elt.type)) {
      case NOTIFICATION_TYPE_DOCUMENT:
        setViewDocumentId(id);
        break;
      case NOTIFICATION_TYPE_FILE:
        setViewFileId(id);
        break;
      case NOTIFICATION_TYPE_MEETING:
        setViewMeetingId(id);
        break;
      case NOTIFICATION_TYPE_SHARE_DETAILS:
        setShareDetailsId(id);
        break;
      default:
        break;
    }
    setRead(parseInt(elt.id));
    setReload(true);

    handleClose();
  };

  const handleNotificationClose = () => {
    setViewDocumentId(0);
    setViewFileId(0);
    setViewMeetingId(0);
    setShareDetailsId(0);
  };

  /* Handle Modal */
  const [viewDocumentId, setViewDocumentId] = useState(0);
  const [viewFileId, setViewFileId] = useState(0);
  const [viewMeetingId, setViewMeetingId] = useState(0);
  const [viewShareDetailsId, setShareDetailsId] = useState(0);
  /* End Handle Modal */

  const [countNofiticationNotRead, setCountNofiticationNotRead] = useState(0);
  const [reload, setReload] = useState(false);

  useEffect(() => {
    const data = getTokenData();
    fetchAllByReceiver(data.login);
  }, []);

  useEffect(() => {
    const data = getTokenData();
    if (reload) {
      fetchAllByReceiver(data.login);
    }
  }, [reload]);

  useEffect(() => {
    setCountNofiticationNotRead(
      notifications.filter((elt) => {
        return elt.date_read === "";
      }).length
    );
  }, [notifications]);

  // End

  return (
    <Fragment>
      {notifications.length > 0 && (
        <>
          <div className="notification">
            <Button
              id="basic-button"
              aria-controls={open ? "basic-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              onClick={handleClick}
            >
              <MdNotifications color="white" size="30px" />
              {countNofiticationNotRead !== 0 && (
                <span className="header__icon__text">
                  {countNofiticationNotRead}
                </span>
              )}
            </Button>

            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              MenuListProps={{
                "aria-labelledby": "basic-button",
              }}
            >
              {notifications
                .sort((a, b) => a.id - b.id)
                .map((elt, key) => {
                  return (
                    <MenuItem
                      className={elt.date_read === "" && "notread"}
                      key={key}
                      onClick={() => handleNotificationClick(elt)}
                    >
                      <div>
                        <p>{elt.description}</p>
                        <small>
                          le{" "}
                          {new Date(elt.date_create).toLocaleDateString(
                            "fr-FR"
                          )}{" "}
                          à {elt.time_create}{" "}
                        </small>
                      </div>
                    </MenuItem>
                  );
                })}
            </Menu>
          </div>
          {viewDocumentId !== 0 && (
            <Modal>
              <div className="modal modal--show">
                <div className="modal__content">
                  <div className="modal__header">
                    <h2 className="modal__title">Détails bulletin</h2>
                    <button
                      className="btn modal__close"
                      onClick={handleNotificationClose}
                    >
                      X
                    </button>
                  </div>
                  <div className="modal__body">
                    <ModalDocument documentId={viewDocumentId} />
                  </div>
                  <div className="modal__footer">
                    <button className="btn" onClick={handleNotificationClose}>
                      Fermer
                    </button>
                  </div>
                </div>
              </div>
            </Modal>
          )}

          {viewFileId !== 0 && (
            <Modal>
              <div className="modal modal--show">
                <div className="modal__content">
                  <div className="modal__header">
                    <h2 className="modal__title">Détails Document</h2>
                    <button
                      className="btn modal__close"
                      onClick={handleNotificationClose}
                    >
                      X
                    </button>
                  </div>
                  <div className="modal__body">
                    <ModalFile fileId={viewFileId} />
                  </div>
                  <div className="modal__footer">
                    <button className="btn" onClick={handleNotificationClose}>
                      Fermer
                    </button>
                  </div>
                </div>
              </div>
            </Modal>
          )}

          {viewMeetingId !== 0 && (
            <Modal>
              <div className="modal modal--show">
                <div className="modal__content">
                  <div className="modal__header">
                    <h2 className="modal__title">Détails réunion</h2>
                    <button
                      className="btn modal__close"
                      onClick={handleNotificationClose}
                    >
                      X
                    </button>
                  </div>
                  <div className="modal__body">
                    <ModalMeeting meetingId={viewMeetingId} />
                  </div>
                  <div className="modal__footer">
                    <button className="btn" onClick={handleNotificationClose}>
                      Fermer
                    </button>
                  </div>
                </div>
              </div>
            </Modal>
          )}

          {viewShareDetailsId !== 0 && (
            <Modal>
              <div className="modal modal--show">
                <div className="modal__content">
                  <div className="modal__header">
                    <h2 className="modal__title">Détails élément</h2>
                    <button
                      className="btn modal__close"
                      onClick={handleNotificationClose}
                    >
                      X
                    </button>
                  </div>
                  <div className="modal__body">
                    <ModalShareDetails shareDetailsId={viewShareDetailsId} />
                  </div>
                  <div className="modal__footer">
                    <button className="btn" onClick={handleNotificationClose}>
                      Fermer
                    </button>
                  </div>
                </div>
              </div>
            </Modal>
          )}
        </>
      )}
    </Fragment>
  );
};

export default Notifications;
